import { render, staticRenderFns } from "./AgendasView.vue?vue&type=template&id=197bd8f7&scoped=true&lang=pug"
import script from "./AgendasView.vue?vue&type=script&lang=js"
export * from "./AgendasView.vue?vue&type=script&lang=js"
import style0 from "./AgendasView.vue?vue&type=style&index=0&id=197bd8f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197bd8f7",
  null
  
)

export default component.exports